import * as React from 'react';
import clsx from 'clsx';
import produce from 'immer';

import {withStyles} from 'common/util/react';
import {react2panel} from 'common/util/react2panel';
import {CollapsibleTheme, SectionReact} from 'common/components/section';
import {InsightsBookmarkParams} from 'common/report/insights/util/types';
import {BookmarkType} from 'common/report/queries/app-api/bookmark-client';
import {Theme} from 'common/report/queries/app-api/themes';

import {ChartAxisCustomization, ChartCustomizationUpdate} from './axis/index';
import css from './index.module.styl?inline';
import styles from './index.module.styl';
import {ChartThemePicker} from './colors';

type ChartCustomizationPanelParams = {
  bookmarkParams: InsightsBookmarkParams;
  bookmarkType: BookmarkType;
  onUpdate: (update: Partial<ChartCustomizationUpdate>) => void;
  onUpdateTheme: (bookmarkParams: InsightsBookmarkParams) => void;
};

export function ChartCustomizationPanel(props: ChartCustomizationPanelParams) {
  const bookmarkTheme = props.bookmarkParams.displayOptions.theme;
  const bookmarkThemeId = bookmarkTheme?.id;
  const bookmarkCustomTheme = (bookmarkTheme as Theme)?.data ? (bookmarkTheme as Theme) : null;

  const handleThemeSelect = (theme: Theme | null) => {
    const params = produce(props.bookmarkParams, (draftParams) => {
      draftParams.displayOptions.theme = theme?.id ? {id: theme.id} : theme;
    });
    props.onUpdateTheme(params);
  };

  const supportsChartCustomization = props.bookmarkType !== BookmarkType.Flows;

  return (
    <div className={clsx(styles.chartCustomizationPanel)}>
      {supportsChartCustomization && (
        <SectionReact className={clsx(styles.section)} headerTitle='Axis' theme={CollapsibleTheme.INLINE}>
          <ChartAxisCustomization
            bookmarkParams={props.bookmarkParams}
            bookmarkType={props.bookmarkType}
            onUpdate={props.onUpdate}
          />
        </SectionReact>
      )}

      <SectionReact className={clsx(styles.section)} headerTitle='Themes' theme={CollapsibleTheme.INLINE}>
        <ChartThemePicker
          allowCreate
          onThemeSelect={handleThemeSelect}
          customTheme={bookmarkCustomTheme}
          activeThemeId={bookmarkThemeId}
        />
      </SectionReact>
    </div>
  );
}

export const ChartCustomizationPanelReact = withStyles(ChartCustomizationPanel, css);
export const ChartCustomizationPanelEl = react2panel(`mp-chart-customization-panel`, ChartCustomizationPanelReact, {
  contexts: [`segmentFilterController`],
});
